import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const setTimerRequest = (value) => ({
  'type': ActionTypes.SET_IMPORTS_TRACKING_TIMER,
  'payload': value,
});

export const fetchPartsImportsInvoices = (parameters = null) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/imports-tracking/invoices${getUrlParameters(parameters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PARTS_IMPORTS_INOVICES,
      [
        {
          'type': ActionTypes.FETCHED_PARTS_IMPORTS_INOVICES,
        },
        () => dispatch(setTimerRequest(true)),
      ],
      [
        ActionTypes.FETCHED_PARTS_IMPORTS_INOVICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  }));
};

export const exportPartsImportsInvoices = (parameters = null) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/imports-tracking/invoices/excel${getUrlParameters(parameters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.EXPORTING_PARTS_IMPORTS_INOVICES,
      [
        {
          'type': ActionTypes.EXPORTED_PARTS_IMPORTS_INOVICES,
        },
      ],
      [
        ActionTypes.EXPORTED_PARTS_IMPORTS_INOVICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  }));
};

export const cleanExportedPartsImportsListUrl = () => ({
  'type': ActionTypes.CLEAN_EXPORTED_PARTS_IMPORTS_INOVICES_URL,
});

export const fetchPartsImportsInvoiceDetails = (invoice) => apiActionCreator({
  'endpoint': `/imports-tracking/invoices?invoice=${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PARTS_IMPORTS_INOVICE_DETAILS,
    ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_DETAILS,
    [
      ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_DETAILS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPartsImportsInvoiceTracking = (invoice) => apiActionCreator({
  'endpoint': `/imports-tracking/invoices/tracking?code=${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PARTS_IMPORTS_INOVICE_TRACKING,
    ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_TRACKING,
    [
      ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_TRACKING_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updatePartsImportsInvoiceTracking = (data = {}) => apiActionCreator({
  'endpoint': '/imports-tracking/invoices/tracking',
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_PARTS_IMPORTS_INOVICE_TRACKING,
    [
      ActionTypes.UPDATED_PARTS_IMPORTS_INOVICE_TRACKING,
      (response) => {
        if (response.message) {
          return MessageActions.addMessageBoxInfo(`Registro Actualizado\n ${response.message}`);
        }
        return MessageActions.addMessageBoxInfo('Registro Actualizado');
      },
    ],
    [ActionTypes.UPDATED_PARTS_IMPORTS_INOVICE_TRACKING_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'contentType': 'application/json',
  'method': 'PUT',
  'data': data,
});

export const createPartsImportsInvoiceTrackingPartial = (data) => apiActionCreator({
  'endpoint': '/imports-tracking/invoices/tracking',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL,
    ActionTypes.CREATED_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL,
    [
      ActionTypes.CREATED_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'contentType': 'application/json',
  'method': 'POST',
  'data': data,
});

export const fetchImportsTrackingStatusList = () => apiActionCreator({
  'endpoint': '/imports-tracking/status-list',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_IMPORTS_TRACKING_STATUS_LIST,
    ActionTypes.FETCHED_IMPORTS_TRACKING_STATUS_LIST,
    [
      ActionTypes.FETCHED_IMPORTS_TRACKING_STATUS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanImportsTrackingInvoicesList = () => ({
  'type': ActionTypes.CLEAN_IMPORTS_TRACKING_INVOICES_LIST,
});

